import {useRouter} from 'next/router';
import {useScopeTranslation} from '@uigstudio/uig-nextjs-helper';

import {ScreenTypes} from '~constants/routes';
import MapIcon from '~assets/images/icons/ui/map-navigation.svg';
import ListIcon from '~assets/images/icons/ui/list-navigation.svg';
import SwitchButton from '~components/atoms/SwitchButton';
import useScreenType from '~hooks/useScreenType';

import {SliderButtons} from './styles';

type NavigationButtonsProps = {
    color: 'white' | 'black';
    absolute?: boolean;
};

const MapListSwitch = ({absolute, color}: NavigationButtonsProps) => {
    const t = useScopeTranslation('list', 'buttons');
    const {isList, isMap} = useScreenType();
    const router = useRouter();

    const changeScreenType = (screen: ScreenTypes) =>
        router.push(
            {
                pathname: router.pathname,
                query: {
                    slug: [screen],
                },
            },
            {
                pathname: screen,
                search: window.location.search,
            },
            {
                shallow: true,
            },
        );

    return (
        <div>
            <SliderButtons absolute={absolute} color={color}>
                <SwitchButton
                    isActive={isMap}
                    onClick={() => changeScreenType(ScreenTypes.Map)}
                    color={color}
                    icon={<MapIcon />}
                    text={t('map')}
                />
                <SwitchButton
                    data-cy={'list-button'}
                    isActive={isList}
                    onClick={() => changeScreenType(ScreenTypes.List)}
                    color={color}
                    icon={<ListIcon />}
                    text={t('list')}
                />
            </SliderButtons>
        </div>
    );
};

export default MapListSwitch;
